import React from 'react';
import { Icon } from 'semantic-ui-react';

type Props = {
  status: number; // e.g. 1-7
  size?: 'mini' | 'tiny' | 'small' | 'large' | 'big' | 'huge' | 'massive';
  onClick?: () => void;
};

// Map status number to label
const statusLabelMap: Record<number, string> = {
  1: 'Not Started',
  2: 'In Progress',
  3: 'Pending',
  4: 'Deferred',
  5: 'Completed',
  6: 'Incomplete',
  7: 'Not Applicable',
};

// Map label to icon and color
const statusIconMap: Record<string, { name: string; color?: string }> = {
  'Not Started': { name: 'circle outline', color: 'grey' },
  'In Progress': { name: 'spinner', color: 'blue' },
  Pending: { name: 'clock outline', color: 'blue' },
  Deferred: { name: 'pause circle', color: 'grey' },
  Completed: { name: 'check circle', color: 'green' },
  Incomplete: { name: 'exclamation circle', color: 'red' },
  'Not Applicable': { name: 'ban', color: 'grey' },
};

export const StatusIcon: React.FC<Props> = ({ status, size = 'small', onClick }) => {
  const label = statusLabelMap[status];
  const icon = statusIconMap[label];

  if (!icon) return null;

  return (
    <Icon
      name={icon.name as any}
      color={icon.color as any}
      size={size}
      title={label}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    />
  );
};
